import { render, staticRenderFns } from "./FaqSection.vue?vue&type=template&id=d0583412&scoped=true"
import script from "./FaqSection.vue?vue&type=script&lang=js"
export * from "./FaqSection.vue?vue&type=script&lang=js"
import style0 from "./FaqSection.vue?vue&type=style&index=0&id=d0583412&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d0583412",
  null
  
)

export default component.exports